<template>
  <el-dialog :visible.sync="formVisible" :close-on-click-modal="false" width="680px" class="reject-dialog"
    @close="handleClose">
    <div slot="title" class="dialog-title">
      <img src="../../../assets/icon-reject.png" alt="reject" class="title-icon" />
      <div class="title-content">
        <div class="title-main">驳回申请</div>
      </div>
    </div>
    <div class="dialog-body">
      <div class="applicant-info" v-if="currentRow">
        <div class="detail-item">
          <span class="label">申请人：</span>
          <span class="value">{{ formatApplicantInfo(currentRow) }}</span>
        </div>
        <div class="detail-item">
          <span class="label">提交时间：</span>
          <span class="value">{{ currentRow.createTime || currentRow.createdTime || '-' }}</span>
        </div>
      </div>
      <div class="detail-box" v-if="currentRow">
        <div class="detail-item">
          <span class="label">发票类型：</span>
          <span class="value">{{ currentRow.type || currentRow.invoiceType || '-' }}</span>
        </div>
        <div class="detail-row">
          <div class="detail-item">
            <span class="label">发票内容：</span>
            <span class="value">{{ currentRow.invoiceContent || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="label">抬头类型：</span>
            <span class="value">{{ currentRow.titleType || currentRow.headerType || '-' }}</span>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-item">
            <span class="label">抬头名称：</span>
            <span class="value">{{ currentRow.title || currentRow.headerName || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="label">税号/身份证号：</span>
            <span class="value">{{ currentRow.taxid || currentRow.taxNo || currentRow.idCard || currentRow.companyTaxNo || '-' }}</span>
          </div>
        </div>
        <div class="detail-item">
          <span class="label">开票金额：</span>
          <span class="value">{{ formatAmount(currentRow.totalPrice || currentRow.invoiceAmount || currentRow.applyAmount) }}</span>
        </div>
      </div>
      <div class="detail-box" v-if="currentRow">
        <div class="detail-row">
          <div class="detail-item">
            <span class="label">订单编号：</span>
            <span class="value">{{ currentRow.ordernum || currentRow.orderNo || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="label">订单类型：</span>
            <span class="value">{{ currentRow.ordertype || currentRow.orderType || '-' }}</span>
          </div>
        </div>
        <div class="product-table" v-if="currentRow && getProductList(currentRow).length > 0">
          <el-table :data="getProductList(currentRow)" border size="small">
            <el-table-column label="商品名称" prop="goodsName" min-width="120" show-overflow-tooltip />
            <el-table-column label="封面" align="center" width="60">
              <template slot-scope="{ row }">
                <el-image v-if="row.goodsUrl" style="width: 40px; height: 40px;" :src="row.goodsUrl"
                  :preview-src-list="[row.goodsUrl]" />
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="商品规格" prop="goodsSkuName" width="100" show-overflow-tooltip />
            <el-table-column label="数量" prop="goodsCount" align="center" width="80" />
            <el-table-column label="开票金额" align="center" width="100">
              <template slot-scope="{ row }">
                {{ formatInvoiceLineAmount(row.invoiceLineAmount) }}
              </template>
            </el-table-column>
          </el-table>
          <div class="table-summary">
            <span class="summary-item">总数量：<em>{{ getTotalQuantity(currentRow) }}</em></span>
            <span class="summary-item">总金额：<em>{{ formatAmount(currentRow.totalPrice) }}</em></span>
          </div>
        </div>
      </div>
      <el-form ref="rejectForm" :model="form" :rules="formRules" label-width="110px" class="reject-form">
        <el-form-item label="驳回原因：" prop="reason" class="reason-input">
          <el-input v-model="form.reason" type="text" placeholder="请输入拒绝开票原因" />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doReject" :loading="isLoading">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { formatInvoiceLineAmount } from './manualInvoice'

export default {
  data() {
    return {
      formVisible: false,
      isLoading: false,
      currentRow: null,
      form: {
        reason: ''
      },
      formRules: {
        reason: [{ required: true, message: '请输入驳回原因', trigger: 'blur' }]
      }
    }
  },
  methods: {
    formatInvoiceLineAmount,
    handleCreate(row) {
      this.currentRow = row
      this.form.reason = ''
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs.rejectForm && this.$refs.rejectForm.clearValidate()
      })
    },
    handleClose() {
      this.currentRow = null
      this.form.reason = ''
    },
    formatApplicantInfo(row) {
      if (!row) return '-'
      if (row.applicantName && row.applicantLevelName && row.applicantMobile) {
        return `${row.applicantName}-${row.applicantLevelName}-${row.applicantMobile}`
      }
      if (row.name && row.pho) {
        return `${row.name}-${row.identity || ''}-${row.pho}`
      }
      return row.applicantInfo || '-'
    },
    formatAmount(val) {
      if (val === null || val === undefined || val === '') return '-'
      const num = Number(val)
      return isNaN(num) ? val : num
    },
    getProductList(row) {
      if (!row) return []
      return row.goodsList || []
    },
    getTotalQuantity(row) {
      const list = this.getProductList(row)
      return list.reduce((sum, item) => sum + (Number(item.goodsCount) || 0), 0)
    },
    getTotalAmount(row) {
      const list = this.getProductList(row)
      return list.reduce((sum, item) => sum + (Number(item.goodsPrice) || 0), 0)
    },
    doReject() {
      this.$refs.rejectForm.validate(valid => {
        const id = this.currentRow && (this.currentRow.invoiceId != null ? this.currentRow.invoiceId : this.currentRow.id)
        if (valid && this.currentRow && id !== undefined && id !== null) {
          const trimmedReason = this.form.reason.trim()
          if (!trimmedReason) {
            this.$message.warning('驳回原因不能为空')
            return
          }
          this.isLoading = true
          this.$emit('reject', {
            invoiceId: id,
            reason: trimmedReason
          }, () => {
            this.isLoading = false
            this.formVisible = false
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.reject-dialog ::v-deep .el-dialog__header {
  padding: 20px 20px 10px;
}
.reject-dialog ::v-deep .el-dialog__body {
  padding: 10px 20px 20px;
}
.dialog-title {
  display: flex;
  gap: 20px;
  align-items: center;
  .title-icon {
    width: 60px;
  }
  .title-content {
    .title-main {
      font-size: 18px;
      color: #000000;
    }
  }
}
.applicant-info {
  padding: 0 0 20px 20px;
  .detail-item {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    margin-bottom: 8px;
    .label {
      color: #666666;
    }
    .value {
      color: #333;
    }
  }
}
.detail-box {
  background: #F8F8F8;
  border-radius: 4px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 10px;
  .detail-row {
    display: flex;
    gap: 24px;
  }
  .detail-item {
    flex: 1;
    display: flex;
    gap: 8px;
    font-size: 14px;
    line-height: 14px;
    .label {
      color: #666666;
      min-width: 80px;
    }
    .value {
      color: #333;
    }
  }
}
.product-table {
  .table-summary {
    margin-top: 12px;
    font-size: 14px;
    text-align: right;
    .summary-item {
      margin-right: 24px;
      em {
        color: #f56c6c;
        font-style: normal;
      }
    }
  }
}
.reject-form {
  margin-top: 10px;
  .reason-input ::v-deep .el-form-item__label {
    line-height: 40px;
  }
}
</style>
